<!-- 计费详情 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title">
        <span>基本信息</span>
      </div>
      <div class="model-content">
        <table class="public-table jbxx-table">
          <tr>
            <td class="td-head">公司名称</td>
            <td>{{userInfo.comName?userInfo.comName:'-'}}</td>
            <td class="td-head">公司简称</td>
            <td>{{userInfo.comBriefName?userInfo.comBriefName:'-'}}</td>
            <td class="td-head">用户类型</td>
            <td><span v-if="userInfo.roleList">{{$common.toStr(userInfo.roleList[0].id,dictionary.user_type)}}</span></td>
          </tr>
          <tr>
            <td class="td-head">当前状态</td>
            <td>{{$common.toStr(userInfo.userStatus,dictionary.user_status)}}</td>
            <td class="td-head">已使用总额（元）</td>
            <td v-if="userInfo.usedAmountTatal || userInfo.usedAmountTatal==0">{{userInfo.usedAmountTatal}}</td>
            <td v-if="!userInfo.usedAmountTatal && userInfo.usedAmountTatal!=0">-</td>
            <td class="td-head">剩余金额（元）</td>
            <td v-if="userInfo.accountAmount || userInfo.accountAmount==0">{{userInfo.accountAmount}}</td>
            <td v-if="!userInfo.accountAmount && userInfo.accountAmount!=0">-</td>
          </tr>
          <tr>
            <td class="td-head">上线期间</td>
            <td v-if="userInfo.startTime">{{userInfo.startTime}} 至 {{userInfo.endTime}}</td>
            <td v-if="!userInfo.startTime">-</td>
            <td class="td-head">上线剩余天数</td>
            <td v-if="userInfo.onLineRemainDays || userInfo.onLineRemainDays==0">{{userInfo.onLineRemainDays}}</td>
            <td v-if="!userInfo.onLineRemainDays && userInfo.onLineRemainDays!=0">-</td>
            <td class="td-head">已使用上线数量</td>
            <td v-if="userInfo.usedOnLineTotal || userInfo.usedOnLineTotal==0">{{userInfo.usedOnLineTotal}}</td>
            <td v-if="!userInfo.usedOnLineTotal && userInfo.usedOnLineTotal!=0">-</td>
          </tr>
          <tr>
            <td class="td-head">测试期间</td>
            <td>{{userInfo.testStartTime}} 至 {{userInfo.testEndTime}}</td>
            <td class="td-head">测试剩余天数</td>
            <td v-if="userInfo.testRemainDays || userInfo.testRemainDays==0">{{userInfo.testRemainDays}}</td>
            <td v-if="!userInfo.testRemainDays && userInfo.testRemainDays!=0">-</td>
            <td class="td-head">已使用测试数量</td>
            <td v-if="userInfo.usedTestTotal || userInfo.usedTestTotal==0">{{userInfo.usedTestTotal}}</td>
            <td v-if="!userInfo.usedTestTotal && userInfo.usedTestTotal!=0">-</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="model-box">
      <div class="model-content model-content-noPadding">
        <el-tabs class="tab-first" v-model="activePage" @tab-click="handleClick">
          <el-tab-pane  label="对账单" name="dzd">
            <el-table
              v-if="activePage=='dzd'"
              :data="dzdData"
              border
              header-row-class-name="tableHead"
              style="width: 80%">
              <el-table-column
              label="期数"
              prop="periodsNum"
              min-width="5%">
              </el-table-column>
              <el-table-column
              label="期间"
              min-width="25%">
              <template slot-scope="scope">
                <span v-if="scope.row.periodsNum">{{scope.row.startTime}} 至 {{scope.row.endTime}}</span>
                <span v-if="!scope.row.periodsNum">合计</span>
              </template>
              </el-table-column>
              <el-table-column
              label="接口种类"
              prop="interfaceNum"
              min-width="20%">
              </el-table-column>
              <el-table-column
              label="使用总次数"
              prop="interfaceUseNum"
              min-width="10%">
              </el-table-column>
              <el-table-column
              label="使用总额度（元）"
              prop="usedAmount"
              min-width="15%">
              </el-table-column>
              <el-table-column
              label="剩余额度（元）"
              prop="surplusAmount"
              min-width="15%">
              </el-table-column>
              <el-table-column
                label="详情"
                min-width="10%">
                <template slot-scope="scope">
                  <a v-if="scope.row.periodsNum" @click="detailsFun(scope.row)">查看</a>
                  <a v-if="scope.row.periodsNum" @click="downLoadFun(scope.row)">下载</a>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane  label="上线使用情况" name="sxsyqk">
            <template v-if="activePage=='sxsyqk'">
              <el-tabs v-model="sxActiveName" @tab-click="handleClick" v-if="sxApiList.length>0">
                <el-tab-pane v-for="(item,index) in sxApiList" :key="index" :label="item.interDesc" :name="item.interId">
                  <el-table
                    v-if="sxActiveName==item.interId"
                    :data="item.items"
                    border
                    header-row-class-name="tableHead"
                    style="width: 65.2%">
                    <el-table-column
                      prop="interName"
                      label="接口名称"
                      min-width="30%">
                    </el-table-column>
                    <el-table-column
                      prop="interUnitPrice"
                      label="接口单价（元）"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      prop="interUseNum"
                      label="使用次数"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      prop="interSubtotal"
                      label="小计（元）"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      label="详情"
                      min-width="10%">
                      <template slot-scope="scope">
                        <a @click="jkdyDetailsFun(scope.row,'onLine')">查看</a>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div v-if="sxApiList.length==0">
                <p class="noData">暂无数据</p>
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane  label="SIT环境使用情况" name="cssyqk">
            <template v-if="activePage=='cssyqk'">
              <el-tabs v-model="csActiveName" @tab-click="handleClick" v-if="csApiList.length>0">
                <el-tab-pane v-for="(item,index) in csApiList" :key="index" :label="item.interDesc" :name="item.interId">
                  <el-table
                    v-if="csActiveName==item.interId"
                    :data="item.items"
                    border
                    header-row-class-name="tableHead"
                    style="width: 65.2%">
                    <el-table-column
                      prop="interName"
                      label="接口名称"
                      min-width="30%">
                    </el-table-column>
                    <el-table-column
                      prop="testNum"
                      label="配置次数"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      prop="testUsedNum"
                      label="使用次数"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      prop="testRemainNum"
                      label="剩余次数"
                      min-width="20%">
                    </el-table-column>
                    <el-table-column
                      label="详情"
                      min-width="10%">
                      <template slot-scope="scope">
                        <a @click="jkdyDetailsFun(scope.row,'test')">查看</a>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
              <div v-if="csApiList.length==0">
                <p class="noData">暂无数据</p>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="对账单明细"
      :visible.sync="dzdDialogVisible"
      width="800px"
      :close-on-click-modal='false'>
      <div class="dialog-content" id='pdfDom'>
        <div v-if="detailInfo.qsInfo.length>0" class="title">第{{detailInfo.qsInfo[0].periodsNum}}期对账单（{{detailInfo.qsInfo[0].startTime}} - {{detailInfo.qsInfo[0].endTime}}）</div>
        <el-table
          :data="detailInfo.qsInfo"
          border
          header-row-class-name="tableHead"
          style="width: 100%">
          <el-table-column
            prop="periodsNum"
            label="期数"
            min-width="10%">
          </el-table-column>
          <el-table-column
            label="期间"
            min-width="30%">
            <template slot-scope="scope">
                <span>{{scope.row.startTime}} 至 {{scope.row.endTime}}</span>
              </template>
          </el-table-column>
          <el-table-column
            prop="interfaceNum"
            label="接口种类"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="interfaceUseNum"
            label="使用总次数"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="usedAmount"
            label="使用总额度（元）"
            min-width="20%">
          </el-table-column>
        </el-table>
        <p class="title2">接口使用详情</p>
        <el-table
          :data="detailInfo.apiInfo"
          style="width: 100%;margin-bottom: 20px;"
          row-key="interId"
          border
          header-row-class-name="tableHead"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column
            prop="interName"
            label="接口名称"
            min-width="44%">
          </el-table-column>
          <el-table-column
            prop="interUnitPrice"
            label="接口单价（元）"
            min-width="18%">
          </el-table-column>
          <el-table-column
            prop="interUseNum"
            label="使用次数"
            min-width="12%">
          </el-table-column>
          <el-table-column
            label="计费方式"
            min-width="12%">
              <template slot-scope="scope">
                <span v-if="scope.row.feeType==1">查得</span>
                <span v-if="scope.row.feeType==2">查询</span>
              </template>
          </el-table-column>
          <el-table-column
            prop="interSubtotal"
            label="小计（元）"
            min-width="14%">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" v-show="!listdown">
        <el-button @click="dzdDialogVisible = false">关 闭</el-button>
        <el-button @click="downLoadFun(detailInfo.qsInfo[0])" type="primary">下 载</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="接口调用详情"
      :visible.sync="jkdyDialogVisible"
      width="1000px"
      :close-on-click-modal='false'>
      <div class="dialog-content">
        <p class="title2">接口信息</p>
        <table class="public-table">
          <tr>
            <td class="td-head">接口类型</td>
            <td>{{jkdyDetailInfo.jklx}}</td>
            <td class="td-head">接口名称</td>
            <td>{{jkdyDetailInfo.jkInfo.interName}}</td>
          </tr>
        </table>
        <p class="title2">调用信息</p>
        <div class="dy-select-box">
          <el-select v-model="jkdySend.period" @change="periodSelectFun()" placeholder="请选择">
            <el-option
              v-for="(item,index) in jkdyOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="jkdySend.timePeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            @change="timePeriodFun()">
          </el-date-picker>
        </div>
        <p class="tishi">共 {{jkdySend.totalCount}} 次调用</p>
        <el-table
          :data="jkdyDetailInfo.dyInfo"
          border
          header-row-class-name="tableHead"
          style="width: 100%">
          <el-table-column
            label="序号"
            align="center"
            width="50">
            <template slot-scope="scope">
              {{(jkdySend.page-1)*jkdySend.pageSize+scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="operationTime"
            label="请求时间"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="requestParams"
            label="请求参数"
            min-width="25%">
          </el-table-column>
          <el-table-column
            prop="requestIp"
            label="请求IP"
            min-width="15%">
          </el-table-column>
          <el-table-column
            prop="responseCode"
            label="响应吗"
            min-width="10%">
          </el-table-column>
          <el-table-column
            label="请求结果"
            v-if="userInfoLogin.role[0]==1"
            min-width="30%">
            <template slot-scope="scope">
              <json-viewer
                class="pre-box resultInstance"
                :value="scope.row.responseData"
                :expand-depth=0
                boxed
                sort>
              </json-viewer>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="jkdySend.totalCount>10"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="jkdySend.page"
          :page-size="jkdySend.pageSize"
          :total="jkdySend.totalCount">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserAddOrEditUser',
  data () {
    return {
      userId:this.$route.query.id || '',
      userInfo:{},
      userInfoLogin:JSON.parse(localStorage.getItem('UserInfo')),
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      activePage: 'dzd',
      dzdData:[],
      sxsyqkData:[],
      cssyqkData:[],
      sxApiList:[],
      csApiList:[],
      sxActiveName: '',
      csActiveName:'',
      dzdDialogVisible:false,
      jkdyDialogVisible:false,
      listdown:false,
      detailInfo:{
        qsInfo:[],
        apiInfo:[],
        jklx:'',
        url:''
      },
      jkdySend:{
        period:'',
        page:1,
        pageSize:10,
        timePeriod:[],
        totalCount:0
      },
      jkdyOptions:[],
      jkdyDetailInfo:{
        jkInfo:{},
        dyInfo:[]
      },
    }
  },
  mounted () {
    var _this=this;
    var allObj=new Object();
    allObj.name="全部";
    allObj.value="";
    _this.jkdyOptions.push(allObj);
    // _this.selectAPIFun();
    _this.getInfoDataFun(1);
    _this.getInfoDataFun(6);
    _this.getInfoDataFun(7);
    _this.getInfoDataFun(8);
    _this.jkdyTimeArrFun();
    console.log(JSON.stringify(_this.userInfoLogin))
  },
  updated(){
     this.expandAll()
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      _this.$nextTick(() => {

      });
    },
    //上线使用情况详情
    interfaceCallDetailFun:function(id){
      this.$router.push({ path: '/jkdyxq', query: {id: id} })
    },
    //对账单详情
    detailsFun:function(obj){
      var _this=this;
      // console.log("obj========="+JSON.stringify(obj))
      _this.detailInfo.qsInfo=[];
      _this.detailInfo.qsInfo.push(obj);
      var sendData=new Object();
      sendData.billId=obj.id;
      sendData.userId=_this.userId;
      _this.$axios.post('/requestApi/fee/find/account/detail',sendData)      
      .then(function(response){
        let data = response.data;
        // console.log("data==================="+JSON.stringify(data));
        if(data.meta.retCode==0){
          _this.detailInfo.apiInfo=data.data;
          // console.log(JSON.stringify(_this.detailInfo.apiInfo))
          _this.dzdDialogVisible=true;
          _this.listdown=false;
        }else{
          console.log(data.meta.friendlyMsg);
        }
      })
      .catch(function(error){
        console.log(error)
      });
    },
    //接口调用详情
    jkdyDetailsFun:function(obj,tag){
      var _this=this;
      if(tag=='test'){
        _this.jkdyDetailInfo.url='/requestApi/fee/find/test/request';
        _this.csApiList.forEach(function(item){
          if(item.interId==_this.csActiveName){
            _this.jkdyDetailInfo.jklx=item.interDesc;
          }
        });
      }else if(tag=='onLine'){
        _this.jkdyDetailInfo.url='/requestApi/fee/find/normal/request';
        _this.sxApiList.forEach(function(item){
          if(item.interId==_this.sxActiveName){
            _this.jkdyDetailInfo.jklx=item.interDesc;
          }
        });
      };
      _this.jkdyDetailInfo.jkInfo=obj;
      _this.jkdySend.page=1;
      _this.jkdySend.period='';
      _this.jkdySend.timePeriod=[];
      _this.jkdyArrDetailsFun();
    },
    //接口详情数据调用
    jkdyArrDetailsFun:function(){
      var _this=this;
      var sendData=new Object();
      if(_this.jkdySend.period=='' && _this.jkdySend.timePeriod.length>0){
        sendData.period=_this.jkdySend.timePeriod[0]+' ~ '+_this.jkdySend.timePeriod[1];
      }else{
        sendData.period=_this.jkdySend.period;
      };
      sendData.page=_this.jkdySend.page;
      sendData.pageSize=_this.jkdySend.pageSize;
      sendData.userId=_this.userId;
      sendData.interId=_this.jkdyDetailInfo.jkInfo.interId;
      // _this.jkdySend.timePeriod;
      _this.$axios.post(_this.jkdyDetailInfo.url,sendData)      
      .then(function(response){
        let data = response.data;
        if(data.meta.retCode==0){
          _this.jkdySend.totalCount=data.data.totalCount;
          _this.jkdyDetailInfo.dyInfo=data.data.resultList;
          _this.jkdyDetailInfo.dyInfo.forEach(function(item){
            item.responseData=JSON.parse(item.responseData);
          });
          _this.jkdyDialogVisible=true;
        }else{
          console.log(data.meta.friendlyMsg);
        }
      })
      .catch(function(error){
        console.log(error)
      });
    },
    //获取调用查询期间
    jkdyTimeArrFun:function(){
      var _this=this;
      _this.$axios.get('/requestApi/dict/find/account/dict?userId='+_this.userId)      
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            data.data.channel_dict.forEach(function(item){
              _this.jkdyOptions.push(item);
            });
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //下载
    downLoadFun:function(obj){
      var _this=this;
      // console.log("obj================"+JSON.stringify(obj));
      var sendData=new Object();
      sendData=obj;
      // var title='第'+obj.periodsNum+'期对账单.pdf';
      sendData.userId=_this.userId;
      _this.$axios.post('/requestApi/download/account/detail',sendData).then(function(response){
        let data = response.data;
        if(data.meta.retCode==0){
          window.open(data.data);
          // let blob = new Blob([data.data], {
          //   'type': 'application/pdf;charset-UTF-8'//word文档为msword,pdf文档为pdf
          // });
          // let objectURL = URL.createObjectURL(blob);
          // let downEle = document.createElement("a");
          // let fname = `download`; //下载文件的名字
          // downEle.href = objectURL;
          // downEle.setAttribute("download", fname);
          // document.body.appendChild(downEle);
          // downEle.click();

        }else{
          console.log(data.meta.friendlyMsg);
        }
      })
      .catch(function(error){
        console.log(error)
      });
    },
    // 查看用户信息
    getInfoDataFun:function(type){
      var _this=this;
      var sendData=new Object();
      sendData.type=type;
      sendData.userId=_this.userId;
      _this.$axios.post("/requestApi/manage/find/user/information",sendData)     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){   
            if(type==1){
              _this.userInfo=data.data;
            }else if(type==6){
              _this.dzdData=data.data;
            }else if(type==7){
              _this.sxApiList=[];
              if(data.data.length>0){
                data.data.forEach(function(item){
                  var itemObj=new Object();
                  itemObj.interId=item.interId;
                  itemObj.interDesc=item.interDesc;
                  itemObj.items=[];
                  item.interfaceUsageOnlineResVoList.forEach(function(itemChild){
                    itemObj.items.push(itemChild)
                  });
                  _this.sxApiList.push(itemObj);
                });
                _this.sxApiList.forEach(function(item){
                  item.items.forEach(function(itemChild){
                    if(itemChild.interUnitPrice==null){
                      itemChild.interUnitPrice=0;
                    };
                    if(itemChild.interfaceTestTotal==null){
                      itemChild.interfaceTestTotal=0;
                    };
                  });
                });
                _this.sxActiveName=_this.sxApiList[0].interId;
              }
            }else if(type==8){
              _this.csApiList=[];
              if(data.data.length>0){
                data.data.forEach(function(item){
                  var itemObj=new Object();
                  itemObj.interId=item.interId;
                  itemObj.interDesc=item.interDesc;
                  itemObj.items=[];
                  item.interfaceUsageTestResVoList.forEach(function(itemChild){
                    itemObj.items.push(itemChild)
                  });
                  _this.csApiList.push(itemObj);
                });
                _this.csApiList.forEach(function(item){
                  item.items.forEach(function(itemChild){
                    if(itemChild.interUnitPrice==null){
                      itemChild.interUnitPrice=0;
                    };
                    if(itemChild.interfaceTestTotal==null){
                      itemChild.interfaceTestTotal=0;
                    };
                  });
                });
                _this.csActiveName=_this.csApiList[0].interId;
              }
            };
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //时间期间
    timePeriodFun:function(){
      var _this=this;
      _this.jkdySend.timePeriod[0]=this.$common.format(_this.jkdySend.timePeriod[0],"yyyy-MM-dd");
      _this.jkdySend.timePeriod[1]=this.$common.format(_this.jkdySend.timePeriod[1],"yyyy-MM-dd");
      _this.jkdySend.period='';
      _this.jkdySend.page = 1;
      _this.jkdyArrDetailsFun();
    },
    //选择时间期间（select）
    periodSelectFun:function(){
      var _this=this;
      _this.jkdySend.timePeriod=_this.jkdySend.period.split(' ~ ');
      _this.jkdySend.page = 1;
      _this.jkdyArrDetailsFun();
    },
    // 分页
    handleCurrentChange:function(val) {
      var _this=this;
      _this.jkdySend.page = val;
      _this.jkdyArrDetailsFun();
    },
    //获取到页面元素  模拟点击可实现让树形表格展开
    expandAll () {
      var els = document.getElementsByClassName('el-table__expand-icon')  //获取点击的箭头元素
      for (let i = 0; i < els.length; i++) {
        els[i].click()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 35%;}
.jbxx-table tr .td-head{width: 15%;}
.select-box-btn{margin: 0 auto;}
.public-table tr td{width: 23.3333%;}
.public-table tr .td-head{width: 10%;}
.title{font-size: 22px;margin-bottom: 20px;text-align: center; color: #333;}
.title2{font-size: 16px;display: block;border-left: 2px solid #333;text-indent: 6px;margin-bottom: 10px;margin-top: 20px;}
.dy-select-box{margin-bottom: 20px;}
.tishi{margin-bottom: 10px;}
.el-dialog .dialog-content>.title2:nth-child(1){margin-top: 0px;}
#pdfDom{padding-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/ChargingDetailPrepay.vue